import React from 'react';
import { Dialog, FlatButton, SelectField, MenuItem, AutoComplete, TextField } from 'material-ui';

const types = ['bulk', 'bulktank', 'car', 'cont', 'livestock', 'mpp', 'pass', 'passcar', 'reefer', 'tank', 'sid', 'tween'];

class EditDialog extends React.Component {
    handleDimensionSelect = (e, i, value) => {
        this.props.updateRate('dimension', {value});
    }

    handleCargoTypeNameSelect = async (e, i) => {
        let { cargoTypes } = this.props;
        await this.props.updateRate('cargoTypeName', cargoTypes[i].name);
        await this.props.updateRate('cargoTypeId', cargoTypes[i]._id);
    }

    handleCargoRateTypeSelect = (e, i, value) => {
        this.props.updateRate('type', value);
    }

    handleCargoTypeSelect = (e, i, value) => {
        this.props.updateRate('cargoType', value);
    }

    render() {
        const { 
            openEditDialog, 
            openAddDialog,
            handleCloseDialog,
            rateEditAdd: { 
                _id, 
                cargoName, 
                cargoTypeName, 
                type, 
                cargoWeight, 
                cargoVolume, 
                port, 
                country,
                cargoType,
                rate: { quantity, dimension, speed, abbreviation, term } 
            }, 
            countries,
            handleSelectCountry,
            ports,
            cargoes,
            changePortAutoCompete,
            choosePortAutoComplete,
            updateRate,
            handleRateEditAdd,
            changeCargoAutoCompete,
            chooseCargoAutoComplete,
            cargoTypes,
        } = this.props;

        const editActions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={() => handleCloseDialog(openEditDialog ? 'edit' : 'add')}
            />,
            <FlatButton
                label="Submit"
                primary={true}
                onClick={() => handleRateEditAdd(openEditDialog ? 'edit' : 'add')}
            />,
        ];
        
        return (
            <div className='row'>
                <Dialog
                    title={openEditDialog ? 'Edit rate' : 'Add rate'}
                    open={openEditDialog || openAddDialog}
                    actions={editActions}
                    onRequestClose={() => handleCloseDialog(openEditDialog ? 'edit' : 'add')}
                >
                    <div className='row'>
                        {
                            openEditDialog ? 
                                <React.Fragment>
                                    <div style={{ padding: '10px' }}>
                                        Cargo name: <span style={{color: 'black'}}>{ cargoName }</span>
                                    </div>
                                    <div style={{ padding: '10px' }}>
                                        Cargo type: <span style={{color: 'black'}}>{ cargoTypeName }</span>
                                    </div>
                                    <div style={{ padding: '10px' }}>
                                        L/D: <span style={{color: 'black'}}>{ type }</span>
                                    </div>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <div>
                                        <AutoComplete 
                                            name='cargo name'
                                            floatingLabelText='Cargo name'
                                            searchText={cargoName}
                                            dataSource={cargoes}
                                            dataSourceConfig={{ text: 'name', value: 'cargo' }}
                                            floatingLabelStyle={{fontSize: '13px'}}
                                            onUpdateInput={changeCargoAutoCompete}
                                            onNewRequest={chooseCargoAutoComplete}
                                            filter={AutoComplete.noFilter}
                                            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                            style={{marginLeft: '10px', width: '220px'}}
                                            popoverProps={{
                                                canAutoPosition: true,
                                            }}
                                            errorText={!cargoName && 'Required'}
                                            errorStyle={{color: 'red'}}
                                            required
                                            fullWidth
                                        />
                                    </div>
                                    <div>
                                        <SelectField 
                                            floatingLabelText="Cargo Type"
                                            style={{width: '220px', marginLeft: '10px'}}
                                            floatingLabelStyle={{fontSize: '13px'}}
                                            value={cargoTypeName || ''}
                                            onChange={this.handleCargoTypeNameSelect}
                                            errorText={!cargoTypeName && 'Required'}
                                            errorStyle={{color: 'red'}}
                                        >
                                            {
                                                cargoTypes && cargoTypes.map(item => {
                                                    return (
                                                        <MenuItem key={item._id} value={item.name} primaryText={item.name} />
                                                    );
                                                })
                                            }
                                        </SelectField>
                                    </div>
                                    <div>
                                        <SelectField 
                                            floatingLabelText="Type"
                                            style={{width: '120px', marginLeft: '10px'}}
                                            floatingLabelStyle={{fontSize: '13px'}}
                                            value={cargoType || ''}
                                            onChange={this.handleCargoTypeSelect}
                                            errorText={!cargoType && 'Required'}
                                            errorStyle={{color: 'red'}}
                                        >
                                            {
                                                types.map(item => {
                                                    return (
                                                        <MenuItem key={item} value={item} primaryText={item} />
                                                    );
                                                })
                                            }
                                        </SelectField>
                                    </div>
                                    <div>
                                        <SelectField 
                                            floatingLabelText="Rate type"
                                            style={{width: '120px', marginLeft: '10px'}}
                                            floatingLabelStyle={{fontSize: '13px'}}
                                            value={type || ''}
                                            onChange={this.handleCargoRateTypeSelect}
                                            errorText={!type && 'Required'}
                                            errorStyle={{color: 'red'}}
                                        >
                                            <MenuItem value='loading' primaryText='loading' />
                                            <MenuItem value='discharging' primaryText='discharging' />
                                        </SelectField>
                                    </div>
                                </React.Fragment>
                        }
                    </div>

                    <div className='row'>
                        <div>
                            <SelectField 
                                style={{width: '220px', marginLeft: '10px'}}
                                floatingLabelText='Country'
                                floatingLabelStyle={{fontSize: '13px'}}
                                maxHeight={400}
                                value={country._id}
                                name='countries'
                                onChange={handleSelectCountry}
                                errorText={!country._id && 'Required'}
                                errorStyle={{color: 'red'}}
                            >
                                {
                                    countries && countries.map(country => {
                                        return (
                                            <MenuItem
                                                key={country._id}
                                                value={country._id}
                                                primaryText={country.name}
                                            />
                                        );
                                    })
                                }
                            </SelectField>
                        </div>
                        <div>
                            <AutoComplete
                                name='port'
                                floatingLabelText='Port name'
                                searchText={port.name}
                                dataSource={ports}
                                dataSourceConfig={{ text: 'name', value: 'port' }}
                                floatingLabelStyle={{fontSize: '13px'}}
                                onUpdateInput={changePortAutoCompete}
                                onNewRequest={choosePortAutoComplete}
                                filter={AutoComplete.noFilter}
                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                style={{marginLeft: '10px', width: '220px'}}
                                popoverProps={{
                                    canAutoPosition: true,
                                }}
                                fullWidth
                                errorText={(!port._id && port.name && 'Wrong port name') || (!port._id && !port.name && 'Required')}
                                errorStyle={{color: 'red'}}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div>
                            <TextField
                                style={{width: '100px', marginLeft: '10px'}}
                                floatingLabelText='Weight'
                                floatingLabelStyle={{fontSize: '13px'}}
                                type='number'
                                value={cargoWeight || ''}
                                onChange={e => updateRate('cargoWeight', e.target.value)}
                                errorText={!(parseInt(cargoVolume) || parseInt(cargoWeight)) && 'Required'}
                                errorStyle={{color: 'red'}}
                            />
                        </div>
                        <div>
                            <TextField
                                style={{width: '100px', marginLeft: '10px'}}
                                floatingLabelText='Volume'
                                floatingLabelStyle={{fontSize: '13px'}}
                                type='number'
                                value={cargoVolume || ''}
                                onChange={e => updateRate('cargoVolume', e.target.value)}
                                errorText={!(parseInt(cargoVolume) || parseInt(cargoWeight)) && 'Required'}
                                errorStyle={{color: 'red'}}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div>
                            <TextField
                                style={{width: '100px', marginLeft: '10px'}}
                                floatingLabelText='Quantity'
                                floatingLabelStyle={{fontSize: '13px'}}
                                type='number'
                                value={quantity || ''}
                                onChange={e => updateRate('quantity', { value: e.target.value })}
                                errorText={!parseInt(quantity) && 'Required'}
                                errorStyle={{color: 'red'}}
                            />
                        </div>
                        <div>
                            <SelectField 
                                floatingLabelText="Dimension"
                                style={{width: '100px', marginLeft: '10px'}}
                                floatingLabelStyle={{fontSize: '13px'}}
                                value={dimension || ''}
                                onChange={this.handleDimensionSelect}
                                errorText={!dimension && 'Required'}
                                errorStyle={{color: 'red'}}
                            >
                                <MenuItem value={'MT'} primaryText="MT" />
                                <MenuItem value={'Days'} primaryText="Days" />
                                <MenuItem value={'Hrs'} primaryText="Hrs" />
                                <MenuItem value={'Cbm'} primaryText="Cbm" />
                            </SelectField>
                        </div>
                        <div>
                            <TextField
                                style={{width: '280px', marginLeft: '10px'}}
                                floatingLabelText='Speed'
                                floatingLabelStyle={{fontSize: '13px'}}
                                value={speed || ''}
                                onChange={e => updateRate('speed', { value: e.target.value })}
                            />
                        </div>
                        <div>
                            <TextField
                                style={{width: '100px', marginLeft: '10px'}}
                                floatingLabelText='Abbreviation'
                                floatingLabelStyle={{fontSize: '13px'}}
                                value={abbreviation || ''}
                                onChange={e => updateRate('abbreviation', { value: e.target.value })}
                            />
                        </div>
                        <div>
                            <TextField
                                style={{width: '100px', marginLeft: '10px'}}
                                floatingLabelText='Term'
                                floatingLabelStyle={{fontSize: '13px'}}
                                value={term || ''}
                                onChange={e => updateRate('term', { value: e.target.value })}
                            />
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default EditDialog;



// WEBPACK FOOTER //
// ./app/components/Cargoes/RequestsLDRates/EditDialog.jsx